/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import React from 'react';
import styles from './FloatingToolbar.module.css';
import ColorIndicator from './ColorIndicator';
export default function FloatingToolbar({
  activeColor,
  activeColorPercent = 100,
  activeColorShape = 'circle',
  activeColorSize = 'sm',
  onColorClick,
  presetName,
  isFlatMode = false,
  onPresetClick,
  onPresetChevronClick,
  zoomText,
  onZoomClick,
  onZoomMouseEnter,
  onZoomMouseLeave,
  onMenuClick,
  isPanMode = false,
  onPanModeClick,
  showPanMode = false,
  className = ''
}) {
  const [isHoveredPan, setIsHoveredPan] = React.useState(false);
  const panIconSrc = isPanMode || isHoveredPan 
    ? "/icons/Icon--Fill-24--Grab.svg" 
    : "/icons/Icon--Fill-24--Spray.svg";
  return (
    <div className={`${styles.container} ${className}`}>
      <ColorIndicator
        color={activeColor}
        percent={activeColorPercent}
        shape={activeColorShape}
        size={activeColorSize}
        onClick={onColorClick}
      />
      <button
        className={styles.zoomBtn}
        onClick={onZoomClick}
        onMouseEnter={onZoomMouseEnter}
        onMouseLeave={onZoomMouseLeave}
      >
        {zoomText}
      </button>
      {showPanMode && (
        <button 
          className={`${styles.panBtn} ${isPanMode ? styles.active : ''}`} 
          onClick={onPanModeClick}
          onMouseEnter={() => setIsHoveredPan(true)}
          onMouseLeave={() => setIsHoveredPan(false)}
          title={isPanMode ? 'Grab Mode' : 'Spray Mode'}
        >
          <img 
            src={panIconSrc} 
            alt="pan-mode"
          />
        </button>
      )}
    </div>
  );
}
